import React, { useState } from 'react'
import { Grid, Typography, Chip } from '@the-platform-group/component-library'
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@the-platform-group/component-library/Icons'
import { usePeopleMergeContext } from '../../contexts/PeopleMergeContext'
import { getJobTitleAndOrgName } from '../../utils'
import { StyledCell } from '../ComparisonRow'

const MultipleJobsRow = ({ label }) => {
  const { mergeData } = usePeopleMergeContext()
  const { sourceJobs, targetJobs } = mergeData.selectedData
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpanded = () => {
    setIsExpanded(prev => !prev)
  }

  const sourceJobsCount = sourceJobs.length
  const targetJobsCount = targetJobs.length
  const maxJobsCount = Math.max(sourceJobsCount, targetJobsCount)

  return (
    <>
      <Grid item container sx={{ borderBottom: '1px solid', borderColor: 'border.secondary' }}>
        <StyledCell
          filled
          container
          item
          xs={2}
          sx={{
            cursor: 'pointer',
          }}
          onClick={toggleExpanded}
        >
          {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          <Typography variant="body2" fontWeight="medium">
            {label}
          </Typography>
        </StyledCell>
        <StyledCell item xs={5}>
          <Typography variant="body2">{sourceJobsCount}</Typography>
        </StyledCell>
        <StyledCell item xs={5}>
          <Typography variant="body2">{targetJobsCount}</Typography>
        </StyledCell>
      </Grid>

      {isExpanded &&
        Array.from({ length: maxJobsCount }).map((_, index) => {
          const sourceJob = sourceJobs[index]
          const targetJob = targetJobs[index]

          return (
            <Grid
              key={index}
              item
              container
              sx={{ borderBottom: '1px solid', borderColor: 'border.secondary' }}
            >
              <StyledCell filled item xs={2} />
              <StyledCell filled item xs={5}>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                  {getJobTitleAndOrgName(sourceJob)}
                  {sourceJob?.isPrimary && (
                    <Chip label="Primary" variant="outlined" color="primary" sx={{ ml: 1 }} />
                  )}
                </Typography>
              </StyledCell>
              <StyledCell filled item xs={5}>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                  {getJobTitleAndOrgName(targetJob)}{' '}
                  {targetJob?.isPrimary && (
                    <Chip label="Primary" variant="outlined" color="primary" sx={{ ml: 1 }} />
                  )}
                </Typography>
              </StyledCell>
            </Grid>
          )
        })}
    </>
  )
}

export default MultipleJobsRow
